module.exports = __webpack_public_path__ + "static/media/dots6.5a4a33f6.png";